<div cdkDropListGroup>
  <div
    cdkDropList
    cdkDropListOrientation="mixed"
    [cdkDropListConnectedTo]="additionalDrops"
    [cdkDropListData]="items"
    [cdkDropListDisabled]="!canDrag"
    [cdkDropListEnterPredicate]="canEnter"
    [class.dnd-container-vertical-scrollbar]="verticalScrollbar"
    [id]="containerId"
    [ngClass]="containerClass"
    (cdkDropListDropped)="onDrop($event)"
    >
    @for (item of items; track item; let i = $index) {
      <div cdkDrag [cdkDragDisabled]="item.disabled" [ngClass]="itemClass">
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ item, index: i }" />
      </div>
    }
  </div>
</div>
